
import { createContext } from 'react';

const SmootherContext = createContext(null);


export default SmootherContext;
